var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-box",class:_vm.opacity,on:{"click":_vm.handleClickShadowBox}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }